import "./OurStory.module.css";
import Header from "@/reusable_sections/Header";
import OurHeartVision from "./sections/OurHeartVision";
import AgriculturalEmpowerment from "./sections/AgriculturalEmpowerment";
import ArchitectsOfLearning from "./sections/ArchitectsOfLearning";
import Footer from "@/reusable_sections/Footer";
export default function OurStoryPage() {
  return <div>
      <Header />
      <OurHeartVision />
      <AgriculturalEmpowerment />
      <ArchitectsOfLearning />
      <Footer />
    </div>;
}